/**
 * Pure predicate factory для проверки принадлежит ли URL нашему backend'у.
 * Вынесено из anon-auth.interceptor.ts чтобы:
 *   1. unit-тестировать без environment-загрузки (которая тянет всё дерево
 *      compob2b-libs и ломает изолированные node-тесты);
 *   2. переиспользовать в других interceptor'ах / handler'ах если понадобится.
 *
 * Контракт:
 *   - protocol-relative `//evil.com/x` → false (выглядит relative, но
 *     указывает на чужой origin);
 *   - relative `/init` → true (CompoApiService добавит serverApi-префикс);
 *   - absolute http(s):// → точный match по origin (не startsWith — иначе
 *     `https://api.compo-soft.ru.attacker.com/...` бы прошёл);
 *   - apiOrigin=null (misconfig) → false на absolute, чтобы Bearer не лил
 *     на random external URL.
 */
export function createIsBackendUrl(apiOrigin: string | null): (url: string) => boolean {
  return (url: string) => {
    if (url.startsWith('//')) {
      return false;
    }
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return true;
    }
    if (!apiOrigin) {
      return false;
    }
    try {
      return new URL(url).origin === apiOrigin;
    } catch {
      return false;
    }
  };
}
